import React from 'react';
import styles from 'assets/css/UserBadge.module.css';
import { IconAngleDownBold } from '@ace/react-icons';
import { useUser} from '@ace/react-utilities';

function UserBadge(props) {
    const { ProfileImageUrl, FirstName } = useUser();

    const handleClick = props.toggleUserMenu;

    return (
        <div className={styles["user-badge"]} onClick={() => handleClick()}>
            <div className={styles["user-badge__img"]} style={{ backgroundImage: "url(" + ProfileImageUrl + ")" }}></div>
            <div className={styles["user-badge__name"]}>{FirstName}</div>
            <IconAngleDownBold fill="#02263C" className={styles["user-badge__toggle"]} />
        </div>
    );
}

export default UserBadge;
